import MicroModal from 'micromodal';
import fetchUserLists from './fetch-user-lists';

export default () => {
  document.addEventListener('click', async (e) => {
    const shareBtn = e.target.closest('[data-open-share-wishlist-link-modal]');
    if (shareBtn) {
      e.preventDefault();
      e.stopPropagation();

      MicroModal.show('share-wishlist-link-modal', {
        disableScroll: true,
        awaitOpenAnimation: true,
        awaitCloseAnimation: true,
        // onShow: () => {
        //   const closeBtn = document.querySelector('#share-wishlist-link-modal .close-modal');
        //   if (closeBtn) {
        //     closeBtn.setAttribute('role', 'button');
        //     closeBtn.focus();
        //     closeBtn.removeAttribute('style');
        //   }
        // }
      });

      const lists = await fetchUserLists();
      const wishlist_item = lists.find(item => item.lname === 'My Wishlist');
      if (!wishlist_item) {
        console.log(`Customer's wishlist not found`);
        return;
      }

      const wishlist_id = wishlist_item.lid;

      if (window._swat) {
        const onSuccess = (link, lid) => {
          let customer_name = window.theme.customer.first_name || '';
          if (window.theme.customer.last_name) {
            customer_name += ` ${window.theme.customer.last_name}`;
          }
          const wishlistInput = document.querySelector('[data-wishlist-link]');
          if (wishlistInput) {
            wishlistInput.value = `https://www.astrthelabel.com/pages/shared-wishlist?hkey=${lid}&lid=${lid}&ff_name=${encodeURIComponent(customer_name)}`;
          }
        };

        const onError = (error) => {
          console.log('Error while generating the link', error);
        };

        window._swat.generateSharedListURL(wishlist_id, onSuccess, onError);
      }
      return;
    }

    const copyBtn = e.target.closest('[data-copy-wishlist-link]');
    if (copyBtn) {
      e.preventDefault();
      const wishlistInput = document.querySelector('[data-wishlist-link]');

      if (wishlistInput) {
        await navigator.clipboard.writeText(wishlistInput.value);
        const span = copyBtn.querySelector('span');
        if (span) {
          span.textContent = 'Copied!';
          window.setTimeout(() => {
            span.textContent = 'Copy link';
          }, 500);
        }
      }
      return;
    }
  });

  // [ADA] Keyboard accessibility
  const share_button = document.querySelector('[data-open-share-wishlist-link-modal]');
  if (share_button) {
    share_button.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        share_button.click();
      }
    });
  }

  const copy_wishlist = document.querySelector('[data-copy-wishlist-link]');
  if (copy_wishlist) {
    copy_wishlist.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        copy_wishlist.click();
      }
    });
  }
};
